
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface PostPreviewNoticeProps {
  locationInfo: string | null;
}

const PostPreviewNotice: React.FC<PostPreviewNoticeProps> = ({ locationInfo }) => {
  return (
    <Card className="mb-6 border-orange-200 bg-orange-50">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 text-orange-800">
          <div className="h-2 w-2 bg-orange-500 rounded-full"></div>
          <span className="font-medium">Preview Mode</span>
        </div>
        <p className="text-sm text-orange-700 mt-1">
          This is how your blog post will appear when published. 
          {locationInfo && ' Location variables have been replaced with actual data.'}
        </p>
      </CardContent>
    </Card>
  );
};

export default PostPreviewNotice;
